export { default } from './TaskExecTaskOwnerItem';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecTaskOwnerItem/index.js